import { render, staticRenderFns } from "./suyun.vue?vue&type=template&id=79d887b2&scoped=true"
import script from "./suyun.vue?vue&type=script&lang=js"
export * from "./suyun.vue?vue&type=script&lang=js"
import style0 from "./suyun.vue?vue&type=style&index=0&id=79d887b2&prod&lang=scss"
import style1 from "./suyun.vue?vue&type=style&index=1&id=79d887b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d887b2",
  null
  
)

export default component.exports